import { render, staticRenderFns } from "./SectionsChangesHistory.vue?vue&type=template&id=512b9a2e&lang=pug&"
import script from "./SectionsChangesHistory.vue?vue&type=script&lang=js&"
export * from "./SectionsChangesHistory.vue?vue&type=script&lang=js&"
import style0 from "./SectionsChangesHistory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports